"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterOperationActions = void 0;
var RegisterOperationActions;
(function (RegisterOperationActions) {
    RegisterOperationActions["OPEN"] = "open";
    RegisterOperationActions["CLOSE"] = "close";
    RegisterOperationActions["MOVEMENT"] = "movement";
    RegisterOperationActions["CART_EMPTY"] = "cart_empty";
    RegisterOperationActions["ITEM_REMOVED"] = "item_removed";
    RegisterOperationActions["APP_START"] = "app_start";
    RegisterOperationActions["EMPLOYEE_SIGN_IN"] = "employee_sign_in";
    RegisterOperationActions["EMPLOYEE_SIGN_OUT"] = "employee_sign_out";
    RegisterOperationActions["SCAN_FAIL"] = "scan_fail";
    RegisterOperationActions["ERROR"] = "error";
    RegisterOperationActions["PRODUCT_REFRESH"] = "product_refresh";
    RegisterOperationActions["TRANSACTION_REFRESH"] = "transaction_refresh";
    RegisterOperationActions["ACCOUNT_REFRESH"] = "account_refresh";
    RegisterOperationActions["CART_AUTO_EMPTY"] = "cart_auto_empty";
})(RegisterOperationActions = exports.RegisterOperationActions || (exports.RegisterOperationActions = {}));
